export default __webpack_public_path__ + "static/media/waveAqua.3f745363.svg";